<script lang="ts">
	export let width: number = 120;
	export let height: number = 70;
	export let className: string = "";
	export let faClass: string = "fa-solid fa-shirt-running";
	// Renders an entirely black passport-style marathon stamp (opacity allowed)
</script>

<div class='relative w-[120px] h-[70px]'>
  <svg
    {width}
    {height}
    viewBox="0 0 120 70"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Marathon passport stamp"
    class={className}
  >
    <title>Marathon Passport Stamp</title>
  
    <!-- Paths and markers -->
    <defs>
      <!-- Top arc for curved text -->
      <path id="topArc" d="M 11 34 A 49 25 0 0 0 109 34" />
    </defs>
  
    <!-- Border: double oval ring -->
    <g fill="none" stroke="#000" stroke-width="1.6">
      <ellipse cx="60" cy="35" rx="55" ry="30" />
      <ellipse cx="60" cy="35" rx="49" ry="25" stroke-width="1.2" />
    </g>
  
    <!-- Scalloped inner edge using rounded dash beads -->
    <ellipse
      cx="60" cy="35" rx="49" ry="25"
      fill="none"
      stroke="#000"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-dasharray="0.6 3.2"
      opacity="0.85"
    />
  
    <!-- Tiny star markers at cardinal points (asterisk style) -->
    <g stroke="#000" stroke-width="1.2" stroke-linecap="round" opacity="0.85">
      <!-- Top -->
      <g transform="translate(60,5)">
        <path d="M 0 -3 L 0 3" />
        <path d="M -3 0 L 3 0" />
        <path d="M -2.2 -2.2 L 2.2 2.2" />
        <path d="M -2.2 2.2 L 2.2 -2.2" />
      </g>
      <!-- Right -->
      <g transform="translate(115,35)">
        <path d="M 0 -3 L 0 3" />
        <path d="M -3 0 L 3 0" />
        <path d="M -2.2 -2.2 L 2.2 2.2" />
        <path d="M -2.2 2.2 L 2.2 -2.2" />
      </g>
      <!-- Bottom -->
      <g transform="translate(60,65)">
        <path d="M 0 -3 L 0 3" />
        <path d="M -3 0 L 3 0" />
        <path d="M -2.2 -2.2 L 2.2 2.2" />
        <path d="M -2.2 2.2 L 2.2 -2.2" />
      </g>
      <!-- Left -->
      <g transform="translate(5,35)">
        <path d="M 0 -3 L 0 3" />
        <path d="M -3 0 L 3 0" />
        <path d="M -2.2 -2.2 L 2.2 2.2" />
        <path d="M -2.2 2.2 L 2.2 -2.2" />
      </g>
    </g>
  
    <!-- Side dots -->
    <circle cx="20" cy="28" r="1.4" fill="#000" opacity="0.85" />
    <circle cx="100" cy="28" r="1.4" fill="#000" opacity="0.85" />
  
    <!-- Curved MARATHON text along top arc (raised and thicker) -->
    <text fill="#000" font-size="9" font-weight="900" letter-spacing="2" text-anchor="middle" style="paint-order: stroke fill; stroke: #000; stroke-width: 0.6;">
      <textPath href="#topArc" startOffset="50%">MARATHON</textPath>
    </text>
  </svg>

  <div class='absolute left-0 top-0 right-0 bottom-0 flex items-center justify-center'>
    <i class={faClass} style="font-size:26px;line-height:1;color:#000;opacity:0.95;"></i>
  </div>
</div>
